module.exports = __webpack_public_path__ + "static/media/cognitive-assessment.bc827d61.png";